import type { ILayoutBlockProps } from './LayoutBlock'

import { styled } from '@linaria/react'
import { ButtonSC } from 'atoms/Button'
import { BANNER_BACK_BUTTON_INDENT } from 'vars/index'

export const LayoutBlockSC = styled.div<{
  blockWidth?: string
  blockHeight?: string
}>`
  width: ${({ blockWidth }) => blockWidth ?? 'initial'};
  max-width: 100%;
  height: ${({ blockHeight }) => blockHeight ?? 'initial'};
  position: relative;
`

export const LayoutBlockPictureSC = styled.picture<
  Pick<ILayoutBlockProps, 'imageHeight' | 'isImageFixed'>
>`
  display: block;
  width: 100%;
  height: ${({ imageHeight }) => imageHeight ?? 'auto'};
  position: ${({ isImageFixed }) => (isImageFixed ? 'absolute' : 'relative')};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`

export const LayoutBlockImageSC = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const LayoutBlockContentSC = styled.div<
  Pick<
    ILayoutBlockProps,
    | 'direction'
    | 'alignItems'
    | 'justifyContent'
    | 'paddings'
    | 'backButtonIndent'
  >
>`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: ${({ direction }) => direction ?? 'initial'};
  align-items: ${({ alignItems }) => alignItems ?? 'initial'};
  justify-content: ${({ justifyContent }) => justifyContent ?? 'initial'};
  padding: ${({ paddings }) => (paddings?.length ? `var(${paddings}) ` : 0)};

  /* Back button styles */
  > ${ButtonSC} {
    position: absolute;
    top: ${({ backButtonIndent }) =>
      `var(${backButtonIndent ?? BANNER_BACK_BUTTON_INDENT.SIZE_20})`};
  }
`
